import {
    composeValidators,
    MAX_LENGTH,
    maxLengthValidator,
    oneLineValidator,
    requiredValidator,
} from "components/Form/Form.utils";
import { Form } from "components/Form/components/Form/Form";
import { TextareaFormComponent } from "components/Form/components/Textarea/TextareaFormComponent";
import { Field } from "react-final-form";
import "./ResourcesPageHeaderTitleForm.scss";

export const ResourcePageHeaderTitleForm = ({
    defaultValue,
    checkIfNameExists,
    isFetching,
}: {
    defaultValue?: string;
    checkIfNameExists?: (e) => void;
    isFetching?: boolean;
}) => (
    <div className="resource-page-header-form" data-testid="resourceFormTitle">
        <Form.Row verticalCenter>
            <Field
                name="name"
                id="recordName"
                validate={composeValidators(
                    requiredValidator,
                    maxLengthValidator(MAX_LENGTH),
                    oneLineValidator
                )}
                defaultValue={defaultValue}
            >
                {({ input, meta }) => {
                    return (
                        <TextareaFormComponent
                            input={input}
                            meta={meta}
                            fieldProps={{
                                onBlur: (e) => {
                                    checkIfNameExists?.(e);
                                    input.onBlur(e);
                                },
                                validateOnMount: !isFetching,
                            }}
                            fieldAttr={{
                                required: true,
                                placeholder: "Enter name",
                                singleLine: true,
                            }}
                        />
                    );
                }}
            </Field>
        </Form.Row>
    </div>
);
